import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import balance from './modules/balance'
import permissions from './modules/permissions'
import clients from './modules/clients'

Vue.use(Vuex)

export interface RootState {
}

export default new Vuex.Store<RootState>({
  modules: {
    auth,
    balance,
    permissions,
    clients
  }
})
